jQuery(document).ready(function($){
  $('body.collection .collection-matrix__wrapper .title-product').matchHeight();
  $('body.collection .collection-matrix__wrapper .type-reviews p.type-products').matchHeight();
  $('body.collection .collection-matrix__wrapper .type-reviews').matchHeight();
  $('body.collection .collection-matrix__wrapper .product_item .image-element__wrap img').matchHeight();

  if($('.collection__filters').length > 0) {
    $('.collection__sort-by-filter').each(function(){  
      var conceptName = $(this).find('select.sort_by').find(":selected").text();
      $(this).find('span.init').text(conceptName);
    })

    $('.collection__sort-by-filter span.init').click(function () {
      
      $(this).parent('.collection__sort-by-filter').find('ul.sort_by').toggleClass("active").toggle();
     
      $(this).parent('.collection__sort-by-filter').siblings('.collection__sort-by-filter').find('ul.sort_by.active').removeClass('active').hide();
    });	
    // $(document).click(function(e){
    //   var container = $(".collection__sort-by-filter span.init");
    //   var container1 = $(".collection__sort-by-filter .filter-options-tags");
    //   if (!container.is(e.target) && container.has(e.target).length === 0 || !container1.is(e.target) && container1.has(e.target).length === 0){
    //     if($('.collection__sort-by-filter ul.sort_by').hasClass('active')) {
    //       $('.collection__sort-by-filter ul.sort_by').hide().removeClass('active');
    //     }
    //   }
    // });
    
    $('.filter-options-tags').click(function () {
      $(this).parent('.collection__sort-by-filter').find('ul.sort_by').toggleClass("active").toggle();
    });
    
    $('body.collection ul.sort_by.active li').click(function () {
      var gettext = $(this).html();
      $(span.init).html('gettext');
    });
    $("ul.sort_by li").click(function() { 
      var name = $(this).text();
      $(this).parents('.collection__sort-by-filter').find('span.init').text(name);
      $(this).parent('ul').removeClass('active').toggle();
      var value = $(this).text() 
      $(this).siblings('li').removeClass('selected');
      $(this).addClass('selected');
      $(this).parents('.collection__sort-by-filter').find('select option').each(function(){
        if($(this).text() == value) {
          $(this).prop('selected',true).change();
        }
      })
    });

    $('button.close').click(function () {
      $(this).parent('.shopify-section.collection-page .section__wrapper .container.top .collection__tag-filter.collection__sort-by-filter.select ul.sort_by.active').removeClass("active");
    });	
    setTimeout(function(){ $('.shopify-section.collection-page .section__wrapper .container.top .field.is-grouped.is-flex-wrap').css('display', '') }, 1000);
  }
  var origin   = window.location.origin;
  $('body.collection .product_item .thumbnail__caption').click(function(e){
    var linkP = window.location.origin + $(this).closest('.product_item').find('.product-thumbnail__title').attr('href');
    window.location.href = linkP;
  });
  $('body.collection .product_item .type-reviews').click(function(e){
    var linkP = window.location.origin + $(this).closest('.product_item').find('.product-thumbnail__title').attr('href')+'#reviews';
    window.location.href = linkP;
  });
  
  var hash = window.location.hash;
  if (hash == "#reviews") {
    $('html, body').animate({
      scrollTop: $(".block__product-yotpo-reviews").offset().top
    }, 2000);
  }

  if ($('.slider-banner').length) {
    var $carousel = $('.slider-banner').flickity({
      groupCells: 1,
      pageDots: false
    });
  }

  var prodHeight;
  window.onload = function(){
      clearTimeout(prodHeight);
      prodHeight = setTimeout(function () {
          setHeight();
      }, 100);
  };
  setHeight();
  function setHeight() {
    $('.related-products .products-slider .gallery-cell .product-thumbnail .title-product').matchHeight();
    $('.related-products .products-slider .gallery-cell').matchHeight();
    $('.quiz .step-4 .options h2').matchHeight();
  };

  var doit;
  window.onresize = function(){
      clearTimeout(doit);
      doit = setTimeout(function () {
          productHeight();
      }, 100);
  };
  productHeight();
  function productHeight(){
    $('.quiz .step-4 .options h2').matchHeight();
    $('.related-products .products-slider .gallery-cell .product-thumbnail .title-product').matchHeight();
    $('.related-products .products-slider .gallery-cell').matchHeight();
  };
  setTimeout(function() {
    if ($('.related-products .products-slider .gallery-cell .product-thumbnail .title-product').length > 0){
      $('.related-products .products-slider .gallery-cell .product-thumbnail .title-product').matchHeight();
    }
  }, 5000);
});

var intervalIdd = window.setInterval(function(){
      $('body.collection .collection-matrix__wrapper .title-product').matchHeight();
}, 2500);

$(document).mouseup(function(e) {
  var container = $("body.collection .container.top .collection__filters");

  // if the target of the click isn't the container nor a descendant of the container
	
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('body.collection .container.top .collection__filters').find('ul.sort_by').removeClass('active');
      // container.hide();
  }
});

if($('.block__recommended-products .js-related-products-slider .products-slider').length>0) {
var productRelated = $('.block__recommended-products .js-related-products-slider .products-slider');
if ($(window).width() <= 768) {
          productRelated.flickity({
            lazyLoad: 2,
            freeScroll: true,
            imagesLoaded: true,
            draggable: true,
            cellAlign: 'left',
            wrapAround: slideData.wrapAround,
            pageDots: false,
            contain: true,
            prevNextButtons: slideData.products_limit > slideData.products_per_slide,
            initialIndex: slideData.initialIndex,
            arrowShape: window.arrowShape,
          });
        }
}